<template>
  <div class="user-avatar-container" :class="[{ online: online }]">
    <div class="user-avatar">
      <template v-if="isValidUrl">
        <img :src="avatar" alt="">
      </template>
      <template v-else>
        <p>
          {{ initials }}
        </p>
      </template>
    </div>
  </div>
</template>

<script>
export default {
  name: 'UserAvatar',
  props: {
    size: {
      type: String,
      default: '36px'
    },
    name: {
      type: String,
      default: null
    },
    avatar: {
      type: String,
      default: null
    },
    online: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    initials () {
      if (this.name) {
        const words = this.name.split(' ')
        if (words.length > 1 && words[0].length && words[1].length) {
          return (words[0][0] + words[1][0]).toUpperCase()
        } else {
          return words[0].substring(0, 2).toUpperCase()
        }
      } else {
        return 'KL'
      }
    },
    isValidUrl () {
      try {
        return Boolean(new URL(this.avatar))
      } catch (e) {
        return false
      }
    }
  }
}
</script>

<style lang="scss" scoped>
$avatar-online-bg-color: #61D373;
.user-avatar-container {
  position: relative;
  width: v-bind('size');
  height: v-bind('size');
  .user-avatar {
    display: flex;
    align-items: center;
    justify-content: center;
    width: v-bind('size');
    height: v-bind('size');
    overflow: hidden;
    border-radius: calc(v-bind('size'));
    background-color: #eeeeee;
    font-size: calc(v-bind('size') / 2.5);
    line-height: 1;
  }
  & + .user-avatar-container {
    margin-left: calc(-1 * (v-bind('size') / 2.5));
  }
  &::after {
    content: '';
    position: absolute;
    bottom: 0;
    right: 0;
    width: calc(v-bind('size') / 4);
    height: calc(v-bind('size') / 4);
    border-radius: calc(v-bind('size') / 8);
  }
  &.online::after {
    background-color: $avatar-online-bg-color;
    border: 1px solid white;
  }
  &:nth-child(1) {
    z-index: 10;
  }
  &:nth-child(2) {
    z-index: 9;
  }
  &:nth-child(3) {
    z-index: 8;
  }
  &:nth-child(4) {
    z-index: 7;
  }
  &:nth-child(5) {
    z-index: 6;
  }
}
</style>
